/**
 * Store-context super properties for analytics.
 *
 * No Mongo store id on the wire (domain resolver only). Key on username +
 * visiting hostname for now. Follow-up: immutable analyticsKey on Store →
 * session, then use that here instead of username.
 *
 * @param {Object} store - session store shape from GET /storefront/session
 * @returns {Object}
 */
export const buildStoreSuperProperties = (store) => {
  const hostname = typeof window !== "undefined" ? window.location.hostname : undefined;

  return {
    store_subdomain: store?.username ?? null,
    store_domain: hostname || null,
    store_name: store?.name ?? store?.storeName ?? null,
    // store_proplan_active: store?.isProplanActive ?? store?.proplan?.isActive ?? false,
  };
};
